export type ExclusionInputType =
  | 'PARAMETER'
  | 'HEADER'
  | 'QUERYSTRING'
  | 'BODY'
  | 'COOKIE'

export const exclusionInputTypeI18nConfig: Record<ExclusionInputType, string> =
  {
    PARAMETER: 'title_exclusionInputType_parameter',
    HEADER: 'title_exclusionInputType_header',
    QUERYSTRING: 'title_exclusionInputType_queryString',
    BODY: 'title_exclusionInputType_body',
    COOKIE: 'title_exclusionInputType_cookie'
  }
